
const chartjs = require('../../../../../components/chart/chartjs')
const chartColor = require('../../../../../components/chart/chart-color')




export function createAllChart(detail, allCharts) {


      const dataChart = lineMultiple(detail.result.charts.usersLines)
      try {
            chartjs.start({
                  elem: 'line',
                  act: 'createMultiple',
                  targetChart: allCharts.userMultipleUser,  //html selecteed
                  data: dataChart.userRequest,
                  options: { name: 'aspectRatio', aspectRatio: 4, legend: true },
            })
            chartjs.start({
                  elem: 'line',
                  act: 'createMultiple',
                  targetChart: allCharts.userMultipleStorage,  //html selecteed
                  data: dataChart.sizeStorage,
                  options: { name: 'aspectRatio', aspectRatio: 4, legend: true },
            })
            chartjs.start({
                  elem: 'line',
                  act: 'createMultiple',
                  targetChart: allCharts.userMultipleDb,  //html selecteed
                  data: dataChart.sizeDb,
                  options: { name: 'aspectRatio', aspectRatio: 4, legend: true },
            })

      } catch (error) { console.log('error', error) }


}/*createAllChart*/




///format data
function lineMultiple(data) {
      try {
            let result = {};

            let valueUserRequest = [];
            let valueSizeStorage = [];
            let valueSizeDb = [];

            data.forEach(element => {
                  valueUserRequest.push({ x: element.month_name, y: parseFloat(element.total_request) })
                  valueSizeStorage.push({ x: element.month_name, y: parseFloat(element.total_file_size_gb) })
                  valueSizeDb.push({ x: element.month_name, y: parseFloat(element.total_db_size_gb) })
            });

            result = {
                  userRequest: [{
                        label: 'User Requests',
                        color: 'blue',
                        tension: 0.3,
                        value: valueUserRequest,
                        borderWidth: 2
                  }],
                  sizeStorage: [{
                        label: 'Storage (GB)',
                        color: 'green',
                        tension: 0.3,
                        value: valueSizeStorage,
                        borderWidth: 2
                  }],
                  sizeDb: [{
                        label: 'DataBase (GB)',
                        color: 'red',
                        tension: 0.3,
                        value: valueSizeDb,
                        borderWidth: 2
                  }]
            };


            return result;


      } catch (err) {
            console.log('err', err);
            return null;
      }
}/*createAllChart*/
